import { render, staticRenderFns } from "./pathDesc.vue?vue&type=template&id=f6194042&scoped=true"
import script from "./pathDesc.vue?vue&type=script&lang=js"
export * from "./pathDesc.vue?vue&type=script&lang=js"
import style0 from "./pathDesc.vue?vue&type=style&index=0&id=f6194042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6194042",
  null
  
)

export default component.exports